import React from 'react'
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import UserProfilePic from '../UserProfilePic';
import DisplayName from '../DisplayName';
import { favoriteReportById } from '../../firestorter'
import { Link } from "react-router-dom";
import { observer } from 'mobx-react'
import { CONSTANTS } from '../../utils';

const FeedItem = observer(class FeedItem extends React.Component {
    render() {
        const report = this.props.report
        const currentUser = this.props.currentUser

        const date = report && report.data && report.data.createdOn && new Date(report.data.createdOn.seconds * 1000)
        const style = { borderBottom: '0.1rem solid rgba(255,255,255,0.3)', display: 'flex', padding: '1rem', lineHeight: 1.7, justifyContent: 'space-between' }

        return (
            <div style={style}>

                <div style={{ display: 'flex' }}>
                    <div>
                        {report.data.userPhotoURL ?
                            <UserProfilePic photoURL={report.data.userPhotoURL} height='2.5rem' _style={{ boxShadow: '0.1rem 0.1rem 0.3rem 0 #333' }} /> :
                            <AccountCircleIcon style={{ fontSize: '3rem' }} />}
                    </div>

                    <div style={{ marginRight: '1rem', fontSize: '1.2rem', textAlign: 'right', alignSelf: 'center' }}>
                        <div>{report.data.location}</div>
                        {report.data.createdOn ? <div>{date.toLocaleString('he-IL', { dateStyle: 'short', timeStyle: 'short' })}</div> : null}

                        <DisplayName uid={report.data.user_id} />
                    </div>
                </div>

                <div className="score" style={{ alignSelf: 'center', whiteSpace: 'nowrap' }}>
                    <div style={{ marginLeft: '5px', display: 'inline-block', fontSize: '1rem' }}>
                        {report.data.hearts || ''}
                    </div>

                    {currentUser ?
                        <div onClick={function () { favoriteReportById(this.props.report.id) }.bind(this)} style={{ display: 'inline-block' }}>{(currentUser.hearted && currentUser.hearted.indexOf(report.id) !== -1) ?
                            <FavoriteIcon htmlColor={CONSTANTS.COLOR.CLEAN} style={{ strokeWidth: '0.15rem', stroke: 'white', verticalAlign: '-0.4rem' }} /> :
                            <FavoriteBorderIcon style={{ verticalAlign: '-0.4rem' }} />}</div> :
                        <Link to="/connect"><FavoriteBorderIcon style={{ verticalAlign: '-0.4rem' }} /></Link>}
                </div>
            </div>
        )
    }

})

export default FeedItem;